import { Component, Fragment, Host, Prop, h } from '@stencil/core';

export interface Step {
  stepNum: number;
  description?: string;
}

@Component({
  tag: 'dynamic-stepper-component',
  styleUrl: 'dynamic-stepper-component.scss',
  shadow: true,
})
export class DynamicStepperComponent {
  @Prop() currentStep: number;
  @Prop() isVertical: boolean = false;

  @Prop() steps: Step[] = [
    { stepNum: 1, description: "Unterlagenauswahl" },
    { stepNum: 2, description: "Vollmacht" },
    { stepNum: 3, description: "Dateneingaben" },
    { stepNum: 4, description: "Zahlung" }
  ]

  render() {
    const numOfSteps = this.steps.length;

    return (
      <Host class={this.isVertical ? 'vertical' : 'horizontal'}>
        {this.steps.map((step, index) => (
          <Fragment>
            <step-component
              key={index}
              step-num={step.stepNum}
              description={step.description}
              current-step={this.currentStep}
              num-of-steps={numOfSteps}
              is-vertical={this.isVertical}
            />
            {index < this.steps.length - 1 && <div class="bar" />}
          </Fragment>
        ))}
      </Host>
    );
  }
}
